import React from "react";

const AdditionalInfo: React.FC<JQI.PersonHeroAdditionalInfoProps> = ({
  cv,
  researchProfile,
}) => (
  <div className="person-hero__info">
    <dl className="person-hero__info-list">
      {
        !!cv &&
        <>
          <dt className="person-hero__info-label">CV:</dt>
          <dd className="person-hero__info-value">
            <a className="link" href={cv} download>
              <span>{cv.split("/").pop()}</span>
            </a>
          </dd>
        </>
      }
      {
        !!researchProfile &&
        <>
          {
            researchProfile.map((profile, i) => {
              if(profile.uri.includes("scholar.google")) {
                profile.title = "Google Scholar";
              }
              return(
                <div key={`research-profile${i}`}>
                  <dt className="person-hero__info-label sr-only">{profile.title ? profile.title : "Research Profile"}</dt>
                  <dd className="person-hero__info-value">
                    <a className="link--external" href={profile.uri} target="_blank">
                      <span className="sr-only">View Profile</span>
                      <span aria-hidden="true">{profile.title ? profile.title : "Research Profile"}</span>
                    </a>
                  </dd>
                </div>
              )
            })
          }
        </>
      }
    </dl>
  </div>
);

export default AdditionalInfo;